/** Safe fallback for help, faq, me, profiles, etc. */
export default function GenericMainContentSkeleton() {
  return (
    <div
      className="skeleton-stage w-full max-w-4xl mx-auto p-6"
      aria-busy
      aria-label="Loading"
    >
      <div className="h-8 w-48 skeleton-shimmer rounded-md mb-6" />
      <div className="space-y-3">
        <div className="h-4 w-full skeleton-shimmer rounded" />
        <div className="h-4 w-full skeleton-shimmer rounded" />
        <div className="h-4 w-[90%] max-w-xl skeleton-shimmer rounded" />
        <div className="h-4 w-full skeleton-shimmer rounded" />
        <div className="h-32 w-full skeleton-shimmer rounded-xl mt-6 opacity-90" />
      </div>
    </div>
  );
}
